<template>
  <div>
    <moon-loader :loading="getIsLoading" style="position: fixed" color="#1e4380" />
    <router-view />
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "App",
  computed: mapGetters(["getIsLoading"])
}
</script>
<style lang="scss">
/* App.vue */
@import "./assets/css/variables.scss";
@import "./assets/css/base.scss";

body {
  font-family: $font-text;
}/* Reports */
h1 {
  font-family: $font-title;
}
h2,
h3,
h4,
h5,
h6 {
  font-family: $font-title;
}
.disclaimer {
  margin-top: 5px;
  margin-bottom: 5px;
  color: $primary-color;
}
.public {
  .carousel-caption {
    color: #fff;
    text-shadow: none;
    font-family: $font-text;
    padding: 0;
    padding: 0;
    height: 100%;
    top: 0;
    display: flex;
    vertical-align: middle;
    justify-content: center;
    flex-direction: column;
    h3 {
      font-size: 2rem;
    }
    p {
      font-size: 1.2rem;
      margin: 0;
    }
  }
}
.navbar {
  .nav-link {
    color: rgba(50, 50, 50, 1) !important;
  }
  .icon {
    background-color: rgba(50, 50, 50, 1);
    position: relative;
  }
  .fa-icon {
    position: relative;
  }
  &.private {
    .nav-link {
      color: rgba(255, 255, 255, 1) !important;
    }
    .icon {
      background-color: #ffffff;
    }
  }
}

.input-group {
    border: 1px solid $primary-color;
    border-radius: 10px;
    .form-control {
      border: none;
      border-radius: inherit;
      background-color: inherit;
      &:focus {
        background-color: inherit;
        border-color: inherit;
        outline: 0;
        box-shadow: none;
      }
    }
    .input-group-addon {
      height: inherit;
      background-color: $primary-color;
      width: 40px;
      border: inherit;
      border-radius: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 1rem;
      color: white;
    }
  }

.tab-font{
  font-family: $font-subtitle;
  font-weight: bold;
  color: $primary-color;
  border-bottom: $primary-color;
}
.active-tab{
  font-weight: bold;
  font-family: $font-subtitle;
}

.mediumTitle{
  text-align: center;
  width: 100px;
  font-size: 20px;
  font-family: $font-subtitle;
}

.cardContainer {
  border: 2px solid #959595;
  width: 100%;
  padding: 30px 40px;
  border-radius: 5px;
}

.pagination .page-item .page-link{
        color: $primary-color;
}

.pagination .page-item.active .page-link {
        color: white;
        background-color: $primary-color;
}
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .navbar {
    &.private {
      .nav-link {
        color: rgba(255, 255, 255, 1) !important;
      }
      .icon {
        background-color: transparent !important;
      }
    }
  }
}
@media (max-width: 576px) {
  .public {
    .carousel-caption {
      left: 5%;
      right: 5%;
      h3 {
        font-size: 1.2rem;
      }
      p {
        font-size: 0.8rem;
      }
    }
    .carousel-control-prev,
    .carousel-control-next {
      width: 5%;
    }
    .navbar-nav {
      .dropdown-menu {
        position: relative;
      }
    }
  }
}
</style>

